import { Brand, Program } from '..';

const WotifPrograms: Record<string, Program> = {
  'au-wotif': {
    id: 'au-wotif',
    name: 'Wotif AU',
    brand: Brand.WOTIF,
    posa: 'AU',
    currency: 'AUD',
    locale: {
      baseName: 'en_AU',
      langId: 3081,
    },
  },
};

export { WotifPrograms };
